import { createSlice, createAction } from '@reduxjs/toolkit';
import { LoginUserInfo } from '@/utils/type';
import { makeFetchSuccessActionType } from '@/utils/makeActionType';
import { LOGIN_OUT, MQTT_TOKEN } from '../actions/common';
import { sendGlobalEvent } from '@/utils/emit';
import { EventName } from '@/utils/constant';
const initState: LoginUserInfo = {
  userInfo: null,
  token: '',
  mqttToken: '',
};

const login = createSlice({
  name: 'login',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        makeFetchSuccessActionType('USER_INFO'),
        (state, action: any) => {
          const res = action.payload;
          state.userInfo = res?.data;
        }
      )
      .addCase(
        makeFetchSuccessActionType('GET_PASSPORT_TOKEN'),
        (state, action: any) => {
          const res = action.payload;
          state.token = res?.data?.accessToken;
        }
      )
      .addCase(makeFetchSuccessActionType(MQTT_TOKEN), (state, action: any) => {
        const res = action.payload;
        state.mqttToken = res?.data?.accessToken;
      })
      .addCase(makeFetchSuccessActionType(LOGIN_OUT), (state, action: any) => {
        state.userInfo = null;
        state.token = '';
        state.mqttToken = '';
        sendGlobalEvent(EventName.CLOSE_MQTT_CLIENT);
      });
  },
});

export default login.reducer;
